import React, { useEffect, useState } from "react";

export default function VirtualTour() {
  const tours = [
    {
      name: "Luxe Heights",
      link: "https://www.coohom.com/pub/tool/panorama/show?obsPlanId=3FO3IEI187UX&locale=en_US&utm_source=light720_share&utm_medium=linkcopy&utm_content=3FO3IEI187UX",
    },
    {
      name: "The Haven",
      link: "https://www.coohom.com/pub/tool/panorama/show?obsPlanId=3FO3COD605ED&locale=en_US&utm_source=light720_share&utm_medium=linkcopy&utm_content=3FO3COD605ED",
    },
    {
      name: "Ezrah",
      link: "https://www.coohom.com/pub/tool/panorama/show?obsPlanId=3FO3BXD6G1EB&locale=en_US&utm_source=light720_share&utm_medium=linkcopy&utm_content=3FO3BXD6G1EB",
    },
  ];

  const [loadingMap, setLoadingMap] = useState({});

  useEffect(() => {
    // simulate staggered loading (more realistic feel)
    tours.forEach((_, i) => {
      setTimeout(() => {
        setLoadingMap((prev) => ({
          ...prev,
          [i]: true,
        }));
      }, 600 + i * 400);
    });
  }, []);

  return (
    <div className="min-h-screen bg-white pt-28 px-4 md:px-10">
      <div className="max-w-7xl mx-auto">

        {/* HEADER */}
        <div className="text-center mb-12">
          <p className="uppercase tracking-[0.3em] text-sm text-gray-500">
            Aspen Plush Homes
          </p>

          <h1 className="text-4xl md:text-6xl font-light text-gray-900 mt-4">
            Virtual Tour Experience
          </h1>

          <p className="max-w-2xl mx-auto text-gray-600 mt-6">
            Explore luxury residences through immersive 360° walkthroughs.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
  {tours.map((tour, idx) => (
    <div
      key={idx}
      className="group rounded-3xl overflow-hidden shadow-sm hover:shadow-2xl transition duration-500 border border-gray-100"
    >

      {/* PREVIEW IMAGE */}
      <div className="relative h-64 overflow-hidden">

        {/* Background image (luxury placeholder) */}
        <div
          className="absolute inset-0 bg-cover bg-center scale-110 group-hover:scale-125 transition duration-700"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1200&q=80')",
          }}
        />

        {/* dark overlay */}
        <div className="absolute inset-0 bg-black/40 group-hover:bg-black/50 transition" />

        {/* badge */}
        <div className="absolute top-4 left-4">
          <span className="bg-white/90 text-black text-[10px] tracking-[0.2em] uppercase px-3 py-1 rounded-full">
            360° Virtual Tour
          </span>
        </div>

        {/* property name */}
        <div className="absolute bottom-4 left-4 right-4">
          <h2 className="text-white text-xl font-medium">
            {tour.name}
          </h2>

          <p className="text-white/80 text-sm mt-1">
            Luxury architectural walkthrough experience
          </p>
        </div>
      </div>

      {/* ACTIONS */}
      <div className="p-6 space-y-3">

        <a
          href={tour.link}
          target="_blank"
          rel="noreferrer"
          className="block w-full bg-black text-white py-2 rounded-xl text-sm uppercase tracking-[0.15em] text-center hover:bg-gray-800 transition"
        >
          Enter Tour
        </a>

        <a
          href="https://wa.me/"
          target="_blank"
          rel="noreferrer"
          className="block w-full border border-gray-300 text-gray-700 py-2 rounded-xl text-sm uppercase tracking-[0.15em] text-center hover:border-black hover:text-black transition"
        >
          Book Viewing
        </a>

      </div>

    </div>
  ))}
</div>

      </div>

      {/* SHIMMER KEYFRAMES */}
      <style>{`
        @keyframes shimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
      `}</style>
    </div>
  );
}